import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SpinnerService } from './services/spinner.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, MatProgressSpinnerModule],
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'Care Plan';
  isLoading = this.spinnerService.loading$;

  constructor(private spinnerService: SpinnerService) {}
}
